import React, { useState } from "react";
import "./CustomPdfViewer.scss";
import { Document, Page } from "react-pdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

function CustomPdfViewer({ file }) {
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const onClickPrev = () => {
    setPageNumber(pageNumber - 1);
  };
  const onClickNext = () => {
    setPageNumber(pageNumber + 1);
  };
  return (
    <div className="pdf-wrapper">
      <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} />
      </Document>

      <div className="d-flex page-controls px-4 py-2">
        <button
          disabled={pageNumber === 1}
          onClick={onClickPrev}
          className="border-0 text-primary bg-transparent px-3"
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </button>
        <p className="mb-0">
          {pageNumber} of {numPages}
        </p>
        <button
          onClick={onClickNext}
          disabled={pageNumber === numPages}
          className="border-0 text-primary bg-transparent  px-3"
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </button>
      </div>
      <p className="mb-0 text-center mt-3 page-numbers text-nowrap">
        Page {pageNumber} of {numPages}
      </p>
    </div>
  );
}
export default CustomPdfViewer;
